import { render, staticRenderFns } from "./RoleEditor.vue?vue&type=template&id=af60584a&scoped=true&"
import script from "./RoleEditor.vue?vue&type=script&lang=js&"
export * from "./RoleEditor.vue?vue&type=script&lang=js&"
import style0 from "./RoleEditor.vue?vue&type=style&index=0&id=af60584a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af60584a",
  null
  
)

component.options.__file = "RoleEditor.vue"
export default component.exports